/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Col_TitleInputs */

const en_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const fr_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const it_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const nl_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const pl_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const fi_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const da_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const sv_portal_scanner_col_title = /** @type {(inputs: Portal_Scanner_Col_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Portal_Scanner_Col_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_col_title = /** @type {((inputs?: Portal_Scanner_Col_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Col_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_col_title(inputs)
	if (locale === "fr") return fr_portal_scanner_col_title(inputs)
	if (locale === "es") return es_portal_scanner_col_title(inputs)
	if (locale === "it") return it_portal_scanner_col_title(inputs)
	if (locale === "nl") return nl_portal_scanner_col_title(inputs)
	if (locale === "pl") return pl_portal_scanner_col_title(inputs)
	if (locale === "fi") return fi_portal_scanner_col_title(inputs)
	if (locale === "da") return da_portal_scanner_col_title(inputs)
	if (locale === "sv") return sv_portal_scanner_col_title(inputs)
	return en_portal_scanner_col_title(inputs)
});